import type { AuthRepository, LoginResponse } from '@contexts/auth/domain';
import type { UseCase } from '@contexts/shared/application';
import { stringValueObject } from '@contexts/shared/domain';

export type ActivateUserInput = {
	token: string;
	password: string;
};

export type ActivateUserOutput = { token: string };

export type ActivateUserUseCase = UseCase<ActivateUserInput, ActivateUserOutput>;

export function activateUserBuilder(authRepository: AuthRepository): ActivateUserUseCase {
	return async function activateUser(input: ActivateUserInput): Promise<ActivateUserOutput> {
		const token = stringValueObject().validate('token', input.token);
		const password = stringValueObject().validate('password', input.password);

		return authRepository.activateUser(token, password);
	};
}
